export function validMin(field) {
    return parseFloat(field.value) >= parseFloat(field.min);
}
